<template>
	<popup title="Select a payment method to add" @close="$emit('close')">
		<template v-slot:content>
			<div class="popup_add_methods" style="padding: 3px 10px;">
				<p>Select a payment method below to be added to your funnel</p>
				<div class="methods_list payment-options-container" style="border-radius: 5px;">

					<div v-if="loading" style="min-height: 200px" class="mt15">
						<v-spinner />
					</div>

					<!-- All -->
					<template v-else >
					<div class="payment-option-header mt15"
					     v-for="(group, itemIndex) in all"
					     :key="'all_'+itemIndex"
					     @click="selectGroup(group)"
					     :data-id="group.id">
						<div class="flex layout-row flex-center">
							<img class="group-logo" :src="group.logo" v-if="group.logo" />
							<span v-else class="name">{{group.title}}</span>
							<span class="count">({{group.user_gateways ? group.user_gateways.length : 0}})</span>
							<div v-if="group.is_fplus">* can only be used in Funnelish Plus funnels</div>
							<div class="flex"></div>
							<div class="flex-none">
								<span class="tag" v-if="group.tag">
									{{group.tag}}
								</span>
							</div>
						</div>

					</div>

					<!-- FPlus -->
						<div class="fplus-only" v-if="isFApps && fplusGroups.length>0">* These payment methods can only be used in Funnelish Plus funnels</div>

						<div class="payment-option-header mt15" :class="{'disabled':isFApps}"
					     v-for="(group, itemIndex) in fplusGroups"
					     :key="'fplus_'+itemIndex"
					     @click="selectGroup(group)"
					     :data-id="group.id">
						<div class="flex layout-row flex-center">
							<img class="group-logo" :src="group.logo" v-if="group.logo" />
							<span v-else class="name">{{group.title}}</span>
							<span class="count">({{group.user_gateways ? group.user_gateways.length : 0}})</span>
							<div class="flex"></div>
							<div class="flex-none">
								<span class="tag" v-if="group.tag">
									{{group.tag}}
								</span>
							</div>
						</div>

					</div>
					</template>

				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button @click="$emit('close')" border >Cancel</v-button>
		</template>
	</popup>

</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import VSpinner from "@/components/base/v-spinner";
export default {
name: "fpay-groups-popup",
	components: {VSpinner, VButton, Popup},
	props: ['groups', 'step', 'loading', 'funnel'],
	data: function () {
		return {
			currentGroupId: 0,
		}
	},
	computed: {
		all() {
			return this.groups.filter(x => !x.is_fplus)
		},
		fplusGroups() {
			return this.groups.filter(x => x.is_fplus)
		},
		isFApps() {
			return this.funnel.funnel_type !== 1
		}
	},
	methods: {
		selectGroup(group) {
			this.currentGroupId=group.id;
			this.$emit('groupClicked', group);
		},
	}
}
</script>

<style lang="scss" scoped>
.group-logo {
	height: 28px;
}
span.tag {
	background: $light-silver;
	white-space: nowrap;
	padding: 4px 10px;
	border-radius: 5px;
	color: $grey;
}
.fplus-only {
	color: red;
	padding: 15px 10px 10px;
	border-bottom: 1px solid $light-grey;
}
.disabled {
	pointer-events: none;
	background: $light-silver;
	.name {
	}
}
</style>
